import Icon from '@klv/atoms/icon';

import * as s from './styles/informationIcon.module.scss';

export const InformationIcon = ({ className = '' }: { className?: string; }) => (
  <div className={s.informationIcon + ' ' + className}>
    <Icon iconName="InformationOutline"/>
  </div>
);
